import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserNurse } from "@fortawesome/free-solid-svg-icons";

import Hero from "./Carousel";
import CampusDiary from "./CampusDiary";
import Prospectus from "./Prospectus";
import Marquee from "./Marquee";
import Figure from "./Media";
import Blocks from "../blocks/Blocks";
import { colleges, courseCount } from "../data/colleges";
import { HOME_STATS } from "../data/defaults";
import { useSection } from "../data/content";
import { useReveal, useCountUp } from "../lib/motion";
import "./Home.css";

import crest from "../assets/images/logo.png";
import aboutus_1 from "../assets/images/aboutUs_1.JPG";
import aboutus_2 from "../assets/images/aboutUs_2.JPG";
import directorImg from "../assets/images/director.jpg";
import principalImg from "../assets/images/principal.jpg";

import Event_1 from "../assets/images/Event_1.JPG";
import Event_2 from "../assets/images/Event_2.JPG";
import Event_3 from "../assets/images/Event_3.JPG";
import Event_4 from "../assets/images/Event_4.JPG";
import Event_5 from "../assets/images/Event_5.JPG";

import inc from "../assets/images/inc.jpg";
import pnrc from "../assets/images/pnrc.jpg";
import babaFarid from "../assets/images/baba_farid.png";
import isd from "../assets/images/isd.jpg";
import ywcoi from "../assets/images/ywcoi.jpg";
import alliedHealthcare from "../assets/images/allied-college-logo.png";
import collegeOfLaw from "../assets/images/law-college-logo.png";

import campus1Img from "../assets/images/campus_1.JPG";
import campus2Img from "../assets/images/campus_2.JPG";
import campus3Img from "../assets/images/campus_3.JPG";
import campus4Img from "../assets/images/campus_4.JPG";
import campus5Img from "../assets/images/campus_5.JPG";
import campus6Img from "../assets/images/campus_6.JPG";
import campus8Img from "../assets/images/campus_8.JPG";
import campus9Img from "../assets/images/campus_9.JPG";
import campus10Img from "../assets/images/campus_10.JPG";
import campus11Img from "../assets/images/campus_11.JPG";
import campus12Img from "../assets/images/campus_12.JPG";
import campus13Img from "../assets/images/campus_13.JPG";
import campus14Img from "../assets/images/campus_14.JPG";
import campus15Img from "../assets/images/campus_15.JPG";
import campus16Img from "../assets/images/campus_16.JPG";
import campus17Img from "../assets/images/campus_17.jpeg";
import campus18Img from "../assets/images/campus_18.jpeg";
import campus19Img from "../assets/images/campus_19.jpeg";
import campus20Img from "../assets/images/campus_20.jpeg";
import campus21Img from "../assets/images/campus_21.jpeg";
import campus22Img from "../assets/images/campus_22.jpeg";
import campus23Img from "../assets/images/campus_23.jpeg";
import campus24Img from "../assets/images/campus_24.jpeg";
import campus25Img from "../assets/images/campus_25.jpeg";
import campus26Img from "../assets/images/campus_26.jpeg";
import campus27Img from "../assets/images/campus_27.jpeg";
import campus28Img from "../assets/images/campus_28.jpeg";
import campus29Img from "../assets/images/campus_29.jpeg";
import campus30Img from "../assets/images/campus_30.jpeg";
import campus31Img from "../assets/images/campus_31.jpeg";

import shahidi1 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/1.jpeg";
import shahidi2 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/2.jpeg";
import shahidi3 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/3.jpeg";
import shahidi4 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/4.jpeg";
import shahidi5 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/5.jpeg";
import shahidi6 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/6.jpeg";
import shahidi7 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/7.jpeg";
import shahidi8 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/8.jpeg";
import shahidi9 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/9.jpeg";
import shahidi10 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/10.jpeg";
import shahidi11 from "../assets/images/shri-guru-arjan-dev-shahidi-divas/11.jpeg";
import environmentDay1 from "../assets/images/campus-activities/environment-day-1.jpeg";
import environmentDay2 from "../assets/images/campus-activities/environment-day-2.jpeg";
import environmentDay3 from "../assets/images/campus-activities/environment-day-3.jpeg";
import republicDay1 from "../assets/images/campus-activities/republic-day-1.jpeg";
import republicDay2 from "../assets/images/campus-activities/republic-day-2.jpeg";
import republicDay3 from "../assets/images/campus-activities/republic-day-3.jpeg";
import republicDay4 from "../assets/images/campus-activities/republic-day-4.jpeg";
import republicDay5 from "../assets/images/campus-activities/republic-day-5.jpeg";
import republicDay6 from "../assets/images/campus-activities/republic-day-6.jpeg";
import republicDay7 from "../assets/images/campus-activities/republic-day-7.jpeg";
import republicDay8 from "../assets/images/campus-activities/republic-day-8.jpeg";
import lohriDay1 from "../assets/images/campus-activities/lohri-day-1.jpeg";
import lohriDay2 from "../assets/images/campus-activities/lohri-day-2.jpeg";
import lohriDay3 from "../assets/images/campus-activities/lohri-day-3.jpeg";

const campusRow1 = [
  campus1Img,
  campus2Img,
  campus3Img,
  campus4Img,
  campus5Img,
  campus6Img,
  campus8Img,
  campus9Img,
  campus10Img,
  campus11Img,
  campus12Img,
  campus13Img,
  campus14Img,
  campus15Img,
  campus16Img,
];
const campusRow2 = [
  campus17Img,
  campus18Img,
  campus19Img,
  campus20Img,
  campus21Img,
  campus22Img,
  campus23Img,
  campus24Img,
  campus25Img,
  campus26Img,
  campus27Img,
  campus28Img,
  campus29Img,
  campus30Img,
  campus31Img,
];

const specialties = [
  "Cardiology",
  "Oncology",
  "Neurosciences",
  "Orthopedics",
  "Pediatrics",
  "Gastroenterology",
  "Transplant",
  "Emergency",
  "Critical Care",
  "Nephrology",
  "Urology",
  "Spine Surgery",
  "Preventive Medicine",
];

const ceremonies = [
  {
    src: Event_1,
    caption:
      "A motivational speech by Puneet Girdhar, Registrar, Punjab Nursing Council.",
  },
  { src: Event_3, caption: "The Lamp Lighting and Oath Taking Ceremony." },
  { src: Event_2 },
  { src: Event_4 },
  { src: Event_5 },
];
const shahidi = [
  shahidi1,
  shahidi2,
  shahidi3,
  shahidi4,
  shahidi5,
  shahidi6,
  shahidi7,
  shahidi8,
  shahidi9,
  shahidi10,
  shahidi11,
].map((src) => ({ src }));
const environmental = [environmentDay1, environmentDay2, environmentDay3].map(
  (src) => ({ src }),
);
const republic = [
  republicDay1,
  republicDay2,
  republicDay3,
  republicDay4,
  republicDay5,
  republicDay6,
  republicDay7,
  republicDay8,
].map((src) => ({ src }));
const lohri = [lohriDay1, lohriDay2, lohriDay3].map((src) => ({ src }));

const diaryCategories = [
  {
    label: "All",
    images: [
      ...ceremonies,
      ...shahidi,
      ...environmental,
      ...republic,
      ...lohri,
    ],
  },
  { label: "Ceremonies", images: ceremonies },
  { label: "Shahidi Diwas", images: shahidi },
  { label: "Environmental Day", images: environmental },
  { label: "Republic Day", images: republic },
  { label: "Lohri", images: lohri },
];

/* ------------------------------------------------------------------ pieces */
const Reveal = ({ children, className = "", n = 0, as: Tag = "div" }) => {
  const [ref, shown] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${n ? `reveal-${n}` : ""} ${
        shown ? "is-visible" : ""
      } ${className}`}
    >
      {children}
    </Tag>
  );
};

const Stat = ({ end, decimals = 0, prefix = "", suffix = "", label }) => {
  const [ref, value] = useCountUp(end, { decimals });
  const shown = decimals > 0 ? value : Number(value).toLocaleString("en-IN");
  return (
    <div className="stat">
      <div ref={ref} className="stat-num">
        {prefix}
        {shown}
        <span className="stat-suffix">{suffix}</span>
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

/* -------------------------------------------------------------------- page */
/* Bundled defaults for the CMS-managed strips. Shape matches what GET /content
   returns (image as { src, key, alt }); the CMS document overrides these when
   present. See src/data/content.js. */
const DEFAULT_APPROVALS = [
  { name: "Indian Nursing Council", note: "Delhi", image: { src: inc } },
  {
    name: "Punjab Nurses Registration Council",
    note: "PNRC",
    image: { src: pnrc },
  },
  {
    name: "Baba Farid University of Health Sciences",
    note: "of Health Sciences",
    image: { src: babaFarid },
  },
  {
    name: "Institute of Skill Development",
    note: "Vocational training",
    image: { src: isd },
  },
  {
    name: "Shri Guru Arjun Dev Ji College of Allied Healthcare",
    note: "Allied Healthcare",
    image: { src: alliedHealthcare },
  },
  {
    name: "Sri Guru Arjun Dev Ji College of Law",
    note: "College of Law",
    image: { src: collegeOfLaw },
  },
];

const DEFAULT_VENTURES = [
  {
    name: "Institute of Skill Development",
    note: "Vocational training & certification",
    image: { src: isd },
  },
  {
    name: "Youth Welfare Council of India",
    note: "Community & youth programmes",
    image: { src: ywcoi },
  },
];

const Home = () => {
  const location = useLocation();
  const approvals = useSection("approvals", DEFAULT_APPROVALS);
  const ventures = useSection("ventures", DEFAULT_VENTURES);
  const homeStats = useSection("homeStats", HOME_STATS);
  const homeExtras = useSection("homeExtras", []);

  useEffect(() => {
    const el = document.getElementById(location.hash.replace("#", ""));
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, [location]);

  return (
    <>
      <Hero />

      {/* -------------------------------------------------- Welcome manifesto */}
      <section className="section welcome" id="welcome">
        <div className="container-narrow welcome-inner">
          <Reveal>
            <img className="welcome-crest" src={crest} alt="Institute crest" />
            <p className="eyebrow">Welcome to the institute</p>
          </Reveal>
          <Reveal n={1}>
            <p className="welcome-statement">
              A place that shapes students into{" "}
              <span className="accent-italic">
                well-rounded, compassionate leaders
              </span>{" "}
              — ready to create a positive impact on the world.
            </p>
          </Reveal>
          <Reveal n={2} className="welcome-sub lead">
            Sri Guru Arjun Dev Ji Group of Institutes equips every student with
            a transformative experience, built on care, real skill and real
            responsibility from day one — whichever college they join.
          </Reveal>
        </div>
      </section>

      {/* ----------------------------------------------------------- Stats band */}
      <section className="section section--forest seam-top stats">
        <div className="container">
          <Reveal className="stats-grid">
            {homeStats.map((s) => (
              <Stat key={s.label} {...s} end={Number(s.end) || 0} />
            ))}
          </Reveal>
        </div>
      </section>

      {/* --------------------------------------------------------------- About */}
      <section className="section section--sage seam-top about">
        <div className="container">
          <Reveal className="about-masthead">
            <div className="about-masthead-title">
              <p className="eyebrow">Who we are</p>
              <h2 className="about-title">
                Four colleges, <em>one standard of teaching</em>
              </h2>
            </div>
            <p className="about-masthead-lead">
              Sri Guru Arjun Dev Ji Group of Institutes, Amritsar, runs four
              colleges under a single seal — nursing, allied healthcare,
              management and law. Whichever a student joins, they get the same
              thing: qualified teaching, recognised qualifications and practice
              that starts in the first year.
            </p>
          </Reveal>

          <div className="about-body">
            <Reveal className="about-media">
              <Figure
                className="about-arch"
                round
                ratio="3 / 4"
                src={aboutus_1}
                alt="Students in class"
              />
              <div className="about-thumb">
                <Figure ratio="1 / 1" src={aboutus_2} alt="Clinical training" />
              </div>
              <span className="about-tag">Est. 2025</span>
            </Reveal>

            <Reveal n={1} className="about-copy">
              <p className="about-text">
                We started in 2025 as a nursing institute and grew into a group.
                Today {courseCount} courses run across four colleges — at the
                bedside, in the laboratory and imaging suite, in the business
                classroom and the workshop, and in the moot court. Each pairs
                teaching with supervised practice, and we support every
                student's personal and professional progress at every step.
              </p>
              <dl className="about-facts">
                {colleges.map((c) => (
                  <div
                    className="about-fact"
                    key={c.slug}
                    style={{ "--tint": `var(--v-${c.slug})` }}
                  >
                    <dt className="about-fact-num figures">
                      {c.courses.length}
                    </dt>
                    <dd className="about-fact-label">
                      <a
                        href={`/colleges/${c.slug}`}
                        className="about-fact-link"
                      >
                        <span className="seal-type">{c.name}</span>
                        <span>{c.tagline}</span>
                      </a>
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>
        </div>

        <Reveal className="about-ticker">
          <span className="about-ticker-label">
            Clinical exposure · Medical &amp; Allied
          </span>
          <div className="about-ticker-viewport">
            <ul className="about-ticker-track" aria-hidden="true">
              {[...specialties, ...specialties].map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>
          <span className="sr-only">
            Students gain clinical exposure across {specialties.join(", ")}.
          </span>
        </Reveal>
      </section>

      {/* -------------------------------------- Colleges — the four registers */}
      <Prospectus />

      {/* ------------------------------------------------------- Approvals */}
      <section className="section approvals seam-top">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <p className="eyebrow">Trusted &amp; accredited</p>
            <h2 className="h-md">Recognised by the councils that matter</h2>
          </Reveal>
        </div>
        {/* the seals run past rather than sitting in a row */}
        <Marquee className="approvals-run" speed="slow">
          {approvals.map((a) => (
            <figure className="approval" key={a.name}>
              <div className="approval-badge">
                <img src={a.image?.src} alt={a.name} />
              </div>
              <figcaption>
                <strong>{a.name}</strong>
                <span>{a.note}</span>
              </figcaption>
            </figure>
          ))}
        </Marquee>
        <div className="container"></div>
      </section>

      {/* ---------------------------------------------------------- Activities */}
      <section className="section activities seam-top" id="activities">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <p className="eyebrow">Life on campus</p>
            <h2 className="h-lg">Our campus diary</h2>
            <p className="lead mx-auto">
              Ceremonies, festivals and everyday moments — flip through by
              category with the arrows, a swipe, or a sideways scroll.
            </p>
          </Reveal>
          <CampusDiary categories={diaryCategories} />
        </div>
      </section>

      {/* --------------------------------------------------------- Campus Life */}
      <section className="section campus-run">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <p className="eyebrow">Campus life</p>
            <h2 className="h-lg">A thriving community</h2>
          </Reveal>
        </div>
        {/* two rows running against each other so the wall never reads as one
            sliding block; hovering either row stops it */}
        <Marquee className="photostrip" speed="slow">
          {campusRow1.map((src, i) => (
            <Figure
              key={i}
              ratio="3 / 2"
              src={src}
              alt=""
              className="figure--tight"
            />
          ))}
        </Marquee>
        <Marquee className="photostrip" speed="slow" reverse>
          {campusRow2.map((src, i) => (
            <Figure
              key={i}
              ratio="3 / 2"
              src={src}
              alt=""
              className="figure--tight"
            />
          ))}
        </Marquee>
      </section>

      {/* ------------------------------------------------------------- Ventures */}
      <section
        className="section section--sage seam-top ventures"
        id="ventures"
      >
        <div className="container">
          <Reveal className="section-head section-head--center">
            <p className="eyebrow">Beyond the colleges</p>
            <h2 className="h-lg">Our ventures</h2>
            <p className="lead">
              Skill-development and youth-welfare initiatives that carry our
              mission past the campus gates — and give our vocational courses
              their industry footing.
            </p>
          </Reveal>
          <Reveal n={1} className="ventures-grid">
            {ventures.map((v) => (
              <article className="venture" key={v.name}>
                <div className="venture-logo">
                  <img src={v.image?.src} alt={v.name} />
                </div>
                <h3 className="venture-name">{v.name}</h3>
                <p className="venture-note">{v.note}</p>
              </article>
            ))}
          </Reveal>
        </div>
      </section>

      {/* --------------------------------------------------- Director's message */}
      <section className="section director seam-top">
        <div className="container">
          <Reveal className="director-lede">
            <div className="director-portrait arch">
              <img
                className="img-cover"
                src={directorImg}
                alt="The Director of Sri Guru Arjun Dev Ji Group of Institutes"
              />
            </div>
            <div className="director-lede-text">
              <p className="eyebrow">From the director</p>
              <blockquote className="director-quote">
                A profession is more than a job — it is a calling.
              </blockquote>
              <p className="director-attribution">
                <span className="director-attribution-icon">
                  <FontAwesomeIcon icon={faUserNurse} />
                </span>
                The Director · Sri Guru Arjun Dev Ji Group of Institutes
              </p>
            </div>
          </Reveal>

          <Reveal n={1} className="director-letter">
            <p className="director-text director-text--lead">
              Welcome to Shri Guru Arjun Dev Ji Institute of Nursing , where
              excellence in nursing education meets compassionate care. As a
              nursing institution, we are committed to fostering an environment
              that combines academic rigor with hands-on experience, ensuring
              that our students are well-equipped to meet the challenges of
              healthcare today.
            </p>
            <p className="director-text">
              Our faculty is dedicated to providing the highest quality of
              education, mentoring, and support to help you develop the skills
              necessary to become a skilled and compassionate nurse. We take
              pride in our state-of-the-art facilities, clinical placements, and
              the diverse learning opportunities available to our students.
            </p>
            <p className="director-text">
              At our Institute, we believe that nursing is more than a
              profession—it is a calling. Our mission is to guide you on a
              transformative journey, helping you grow into a confident,
              knowledgeable, and empathetic healthcare professional. We invite
              you to join our community of learners and leaders and make a
              meaningful impact on the lives of others.
            </p>
            <p className="director-text">
              Together, let us embrace the future of healthcare and contribute
              to the well-being of individuals and communities.
            </p>
            <p className="director-sign">
              The Director
              <span>Sri Guru Arjun Dev Ji Group of Institutes</span>
            </p>
          </Reveal>
        </div>
      </section>

      {/* -------------------------------------------------- Principal's message */}
      <section className="section principal seam-top">
        <div className="container">
          <Reveal className="principal-head">
            <p className="eyebrow">From the principal</p>
            <p className="principal-statement">
              Nursing is not merely a profession; it is a noble commitment to
              humanity.
            </p>
          </Reveal>

          <div className="principal-body">
            <Reveal className="principal-aside">
              <figure className="principal-portrait arch">
                <img
                  className="img-cover"
                  src={principalImg}
                  alt="Dr. Sukhbir Kaur, Principal of Sri Guru Arjun Dev Ji Institute of Nursing"
                />
              </figure>
              <p className="principal-name">Dr. Sukhbir Kaur</p>
              <ul className="principal-creds">
                <li>FPDNR</li>
                <li>Ph.D. (N)</li>
                <li>MSN — CMC, Ludhiana</li>
                <li>BSN</li>
                <li>RN — PGI, Chandigarh</li>
                <li className="principal-cred--honour">Gold Medalist, BFUHS</li>
              </ul>
              <p className="principal-role">
                Principal
                <span>
                  Sri Guru Arjun Dev Ji Institute of Nursing, Amritsar
                </span>
              </p>
            </Reveal>

            <Reveal n={1} className="principal-letter">
              <p className="principal-salutation">
                Dear Students, Parents, Faculty Members, and Well-Wishers,
              </p>
              <p className="principal-text principal-text--lead">
                It gives me immense pleasure and a deep sense of responsibility
                to welcome you to our institution. As a Principal, I feel
                honoured to be a part of an institution committed to shaping the
                future of nursing through quality education, compassionate care,
                professional excellence, and strong ethical values.
              </p>
              <p className="principal-text">
                Our aim is to nurture competent, compassionate, confident, and
                socially responsible nursing professionals who are equipped to
                meet the evolving healthcare needs of society. We believe that
                education extends beyond classrooms and textbooks. It is a
                continuous process of developing knowledge, skills, critical
                thinking, empathy, leadership, and a strong sense of
                responsibility.
              </p>
              <p className="principal-text">
                Our institution is dedicated to providing a supportive and
                stimulating learning environment where every student is
                encouraged to discover their potential, pursue excellence, and
                develop into a lifelong learner. Here we focus on providing
                simulation-based training through evidence-based practices which
                will ensure a better healthcare force for the welfare of society
                and nation. Through the collective efforts of our management,
                dedicated faculty, committed students, supportive parents, and
                the entire college community, we strive to create an environment
                of academic growth, professional development, innovation, and
                personal transformation.
              </p>
              <p className="principal-text">
                As we move forward, my vision is to strengthen the culture of
                excellence, teamwork, discipline, integrity, and continuous
                improvement. I firmly believe that the success of an institution
                is built through collaboration, mutual respect, and a shared
                commitment to its mission and values.
              </p>
              <p className="principal-text">
                I warmly invite every member of our college community to join me
                in this journey of growth and excellence. Together, let us
                empower our students to become knowledgeable professionals,
                compassionate caregivers, ethical leaders, and valuable
                contributors to society.
              </p>
              <blockquote className="principal-epigraph">
                Education gives us knowledge, compassion gives us purpose, and
                service gives our profession its true meaning.
              </blockquote>
              <p className="principal-text">
                With best wishes for a bright, successful, and meaningful
                future.
              </p>
              <p className="principal-sign">
                Warm regards,
                <strong>Dr. Sukhbir Kaur</strong>
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* CMS-managed extra sections — renders nothing until an admin adds blocks */}
      <Blocks blocks={homeExtras} />
    </>
  );
};

export default Home;
